export enum EnFieldType {
    Input,
    TextArea,
    SlideToggle,
    RadioGroup
  }